<form [formGroup]="form" (ngSubmit)="onSubmit($event)">
  <input type="email" formControlName="email" placeholder="Enter your email here" i18n-placeholder="@@front.home.getStartedForm.email.placeholder">
  <div class="p-1"></div>
  <button type="submit" class="submit" i18n="@@front.home.getStartedForm.button">Get Started</button>
</form>